import React from 'react';
import Loading from '../../components/Loading/Loading';
import { ChairInfo, Info, TableFriendlyName } from '../../store/info/types';
import { Role } from '../../store/conference/types';
import { AppState } from '../../store/state';
import { selectInfo, selectKeywordState, selectTrackRoles } from '../../store/selectors';
import { AppDispatch } from '../../store/store';
import { connect } from 'react-redux';
import MyGridRedux from '../../components/MyGridRedux/MyGridRedux';
import { formatKeywordColumn } from '../../helpers/table';
import { useTranslation } from 'react-i18next';
import { doesHandleReviewers } from '../../helpers/role';
import useFetchTableData from '../../store/table/useFetchTableData';
import { stringifyOrganization } from '../../helpers/users';

interface Props {
  loading: boolean;
  info: Info;
  roleById: { [key: string]: Role };
  keywordById: { [key: number]: Keyword };
}

const ReviewersToPapersPage: React.FC<Props> = ({ loading, info, roleById, keywordById }) => {
  const { t, i18n } = useTranslation();
  const friendlyName: TableFriendlyName = 'reviews_to_papers';
  const [fetchData, fetchCustomColumnsData] = useFetchTableData(friendlyName);

  if (loading) {
    return <Loading />;
  }

  const chairInfo = info as ChairInfo;

  /* Build input data */
  const inputData: unknown[] = [];
  Object.values(chairInfo.users.byId).forEach((register) => {
    register.role_ids.forEach((roleId, index) => {
      const role = roleById[roleId];
      if (role.type == 'reviewer' && !doesHandleReviewers(role)) {
        const personRoleId = register.person_role_ids[index];

        const newRegister = {
          ...register,
          id: personRoleId,
          role_id: roleId,
          person_role_id: personRoleId,
        };

        // Add Role description
        // @ts-ignore
        newRegister.role = roleById[roleId].description;

        formatKeywordColumn(newRegister, keywordById);

        newRegister.organization = stringifyOrganization(newRegister);

        inputData.push(newRegister);
      }
    });
  });

  return (
    <>
      <div className="h-full">
        {loading ? (
          <Loading />
        ) : (
          <MyGridRedux
            friendlyName={friendlyName}
            inputData={inputData as Record<string, unknown>[]}
            getInfoAction={fetchData}
            getCustomColumnsData={fetchCustomColumnsData}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  loading: selectInfo(state).loading,
  info: state.info.info,
  roleById: selectTrackRoles(state),
  keywordById: selectKeywordState(state).keywordById,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewersToPapersPage);
